import { Pipe, PipeTransform } from '@angular/core';
import { FieldSetting } from '@src/app/features/web-submission/models/field-setting.model';

@Pipe({
  name: 'fieldSettingPipe',
})
export class FieldSettingPipe implements PipeTransform {
  transform(
    fieldSettingMap: { [key: string]: FieldSetting } | any,
    args: {
      key: (string | undefined) | (string | undefined)[];
      isReturn: boolean;
      otherCondition?: boolean;
    }
  ): boolean { //: boolean | undefined {
    const { key, isReturn, otherCondition } = args;

    if (!key) {
      return false;
    }

    if (Array.isArray(key)) {
      return key.some(
        (fieldKey) =>
          !!fieldKey &&
          this.isShow({
            fieldSettingMap,
            key: fieldKey,
            isReturn,
            otherCondition,
          })
      ) ?? false;
    }

    return this.isShow({
      fieldSettingMap,
      key,
      isReturn,
      otherCondition,
    }) ?? false;
  }

  private isShow(params: {
    fieldSettingMap: { [key: string]: FieldSetting };
    key: string;
    isReturn: boolean;
    otherCondition?: boolean;
  }): boolean | undefined {
    const { fieldSettingMap, key, isReturn, otherCondition } = params;

    if (fieldSettingMap[key]) {
      if (isReturn) {
        if (otherCondition !== undefined) {
          return fieldSettingMap[key].isReturnedShow && otherCondition;
        } else {
          return fieldSettingMap[key].isReturnedShow;
        }
      } else {
        if (otherCondition !== undefined) {
          return fieldSettingMap[key].isDisplay && otherCondition;
        } else {
          return fieldSettingMap[key].isDisplay;
        }
      }
    }
    return false;
  }
}
